export enum YES_NO {
  yes = 'yes',
  no = 'no'
}
export interface CallMeFormState {
  name: string;
  number: string;
  day?: DayType | '';
  time?: { label: string; value: Date } | '';
  formErrors: {
    numValidity: 'VALID' | 'EMPTY' | 'INVALID';
    nameInvalid: boolean;
  };
  isCustomer: string;
  callMeActionStatusMessage: string;
  callMeActionStatus:
    | 'initial'
    | 'loading'
    | 'submittedSuccessfully'
    | 'submittedFailure';
}

export type DayType = {
  label: string;
  value: number;
  dateValue: Date;
};

export enum CallMeActionKind {
  SET_LOADING = 'SET_LOADING',
  SET_SUCCESS = 'SET_SUCCESS',
  SET_FAILURE = 'SET_FAILURE',
  SELECT_CUSTOMER_RELATIONSHIP = 'SELECT_CUSTOMER_RELATIONSHIP',
  ENTER_NAME = 'ENTER_NAME',
  ENTER_NUM = 'ENTER_NUM',
  CHOOSE_DAY = 'CHOOSE_DAY',
  CHOOSE_TIME = 'CHOOSE_TIME',
  VALIDATE_ENTER_NUM = 'VALIDATE_ENTER_NUM'
}

export type CallMeAction = {
  type: CallMeActionKind;
  payload: any;
};

export interface CallMeAppProps {
  additionalDataUrl: string | null | undefined;
}

export interface TimeslotOption {
  label: string;
  value: Date;
}

export interface QueueDetailsType {
  errand: string;
  menuchoice: string;
  entrance: string;
}

export type WorkingDays =
  | 'MANDAG'
  | 'TIRSDAG'
  | 'ONSDAG'
  | 'TORSDAG'
  | 'FREDAG';
export interface WorkingHours {
  [key: string]: string;
}

export interface EnonicDataType {
  holidays: string;
  lunch_break: string;
  open_hours: string;
  open_hours_MANDAG: string;
  open_hours_TISDAG: string;
  open_hours_ONSDAG: string;
  open_hours_TORSDAG: string;
  open_hours_FREDAG: string;
  now_queue_test: string; // Format of value should be <errand>|<menuchoice>|<entrance>
  now_queue_prod: string; // Format of value should be <errand>|<menuchoice>|<entrance>
  later_queue_test: string; // Format of value should be <errand>|<menuchoice>|<entrance>
  later_queue_prod: string; // Format of value should be <errand>|<menuchoice>|<entrance>
}
